// Colour options for the banner component defined in Figma
export enum bannerColour {
    blue,
    yellow,
    green,
    red,
    ligntBlue,
    fadedGreen,
    fadedRed,
    fadedBlue
}